module.exports = __webpack_public_path__ + "img/chevron_down.5c948d9c.svg";